import React from "react";

function tooltipMetadata(item) {
  if (item.kind === "event") return item.eventType.replaceAll("_", " ");
  if (item.kind === "esoteric") return `${item.traditionLabel} · ${item.typeLabel}`;
  return item.eraLabel;
}
function FigureWorks({ item }) {
  if (item.works.length === 0) {
    return <p className="history-chart__tooltip-more">No principal work is catalogued here.</p>;
  }

  return (
    <>
      <p className="history-chart__tooltip-label">Principal works</p>
      <ul>
        {item.works.map((work) => (
          <li key={`${work.title}-${work.year}`}>
            <cite>{work.title}</cite>{work.year ? ` (${work.year})` : ""}
          </li>
        ))}
      </ul>
      {item.workCount > item.works.length && (
        <p className="history-chart__tooltip-more">
          +{item.workCount - item.works.length} more on the profile
        </p>
      )}
    </>
  );
}

export default function TimelineTooltip({ tooltip }) {
  if (!tooltip) return null;

  const { item } = tooltip;
  const traditionClass = item.tradition ? ` history-chart__tooltip--${item.tradition}` : "";

  return (
    <div
      id="history-chart-tooltip"
      role="tooltip"
      className={`history-chart__tooltip history-chart__tooltip--${item.kind}${traditionClass}`}
      style={{ left: `${tooltip.x}px`, top: `${tooltip.y}px` }}
      data-testid="history-chart-tooltip"
    >
      <p className="history-chart__tooltip-title">{item.name}</p>
      <p className="history-chart__tooltip-meta">{item.dates} · {tooltipMetadata(item)}</p>
      {item.historicityLabel && (
        <p className="history-chart__tooltip-status">{item.historicityLabel}</p>
      )}
      {item.periodLabel && (
        <p className="history-chart__tooltip-period">Period: {item.periodLabel}</p>
      )}
      <p>{item.summary}</p>
      {item.kind === "figure" ? (
        <FigureWorks item={item} />
      ) : (
        <>
          <p>{item.significance}</p>
          <p className="history-chart__tooltip-source">Source: {item.sourceLabel}</p>
        </>
      )}
      {tooltip.pinned && <p className="history-chart__tooltip-hint">Tap again to open.</p>}
    </div>
  );
}
